// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data from "common/src/data/Data.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function PlGlobalStats$Cell(Props) {
  var suffix = Props.suffix;
  var icon = Props.icon;
  var num = Props.num;
  var label = Props.label;
  return React.createElement("div", {
              className: "font-montserrat font-medium flex flex-col items-center bg-bg0 p-[11px] rounded w-[74px] lg:w-[80px]"
            }, React.createElement("div", {
                  className: "flex items-center font-medium pb-[5px] leading-none text-[25px] font-semibold"
                }, Belt_Option.mapWithDefault(icon, null, (function (icon) {
                        return React.createElement("div", {
                                    className: "w-[22px] h-[22px] ml-[-5px] mr-[1px]"
                                  }, icon);
                      })), React.createElement("div", undefined, num, Belt_Option.mapWithDefault(suffix, null, (function (suffix) {
                            return React.createElement("span", {
                                        className: "text-lg leading-none"
                                      }, suffix);
                          })))), React.createElement("div", {
                  className: "text-[14px] lg:text-[15px] font-montserrat"
                }, label));
}

var Cell = {
  make: PlGlobalStats$Cell
};

function PlGlobalStats(Props) {
  var stats = Props.stats;
  var set = TftSet.use(undefined);
  CdnAtom.usePath4(undefined);
  var topCarry = Data.fixId(stats.topCarry);
  return React.createElement("div", {
              className: "flex flex-col items-center"
            }, React.createElement("div", {
                  className: "grid gap-3 grid-cols-[auto_auto]"
                }, React.createElement(PlGlobalStats$Cell, {
                      num: String(stats.games),
                      label: "Games"
                    }), React.createElement(PlGlobalStats$Cell, {
                      num: Global.toFixed(undefined, stats.avgPlace),
                      label: "Avg"
                    }), React.createElement(PlGlobalStats$Cell, {
                      num: String(stats.top4),
                      label: "Top 4"
                    }), React.createElement(PlGlobalStats$Cell, {
                      num: Global.formatPct(undefined, Global.f(stats.top4) / Global.f(stats.games)),
                      label: "Top 4%"
                    }), React.createElement(PlGlobalStats$Cell, {
                      num: String(stats.win),
                      label: "Won"
                    }), React.createElement(PlGlobalStats$Cell, {
                      num: Global.formatPct(undefined, Global.f(stats.win) / Global.f(stats.games)),
                      label: "Won %"
                    })), React.createElement("div", {
                  className: "relative overflow-hidden mt-3 flex flex-col items-center bg-bg0 p-[10px] rounded w-[160px] lg:w-[172px]",
                  style: Global.s({
                        textShadow: "-1px 0 2px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.2), 1px 0 2px rgba(0, 0, 0, 0.2), 0 -1px 2px rgba(0, 0, 0, 0.2)"
                      })
                }, React.createElement("div", {
                      className: CssJs.merge([
                            "absolute z-0 top-0 left-0 w-[66px] h-[66px] rounded",
                            CssJs.style([
                                  CssJs.unsafe("backgroundImage", set >= 90 && set < 100 ? "url(https://ap.tft.tools/img/cd14/face_base/" + Belt_Array.getExn(topCarry.split("_"), 1) + ".jpg?w=66)" : "url(https://ap.tft.tools/img/cd14/face/" + topCarry + ".jpg?w=66)"),
                                  CssJs.unsafe("maskImage", "linear-gradient(to right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.6) 60%, rgba(0, 0, 0, 0.05))"),
                                  CssJs.unsafe("backgroundSize", "66px")
                                ])
                          ])
                    }), React.createElement("div", {
                      className: "z-10 flex items-center font-medium pb-[10px] leading-none text-[20px] font-montserrat"
                    }, React.createElement("div", {
                          className: "flex items-center"
                        }, React.createElement("div", undefined, React.createElement(UnitName0.make, {
                                  unit: topCarry
                                })))), React.createElement("div", {
                      className: " font-montserrat z-10"
                    }, "Top Carry")));
}

var make = PlGlobalStats;

export {
  Cell ,
  make ,
  
}
/* Data Not a pure module */
